import { SDK } from 'service-manager'

import { env } from '@app/env'

export const serviceManagerSDK = () => {
  return new SDK(env.REACT_APP_SERVICE_MANAGER_PUBLIC_URL)
}
